import React, { Component } from 'react';
import './styles/ModalDrugWebsite.css';

class ModalDrugWebsite extends Component{

    componentDidMount(){
        document.addEventListener('mousedown', this.handleClick, false);
    }

    componentWillUnmount(){
        document.removeEventListener('mousedown', this.handleClick, false);
    }

    handleClick = (e) =>{
        let modal = document.getElementById('modalWindow');

        if(this.props.showModalWindow && e.target.id !== modal.id && !modal.contains(e.target)){
           this.props.closeModal();
        }
    }

    openWebsite(e){
        window.open(this.props.website);
        this.props.closeModal(e);
        e.preventDefault();
    }

    render(){

        const backdropStyle = {
            position: 'fixed',
            top: 0,
            bottom: 0,
            left: 0,
            right: 0,
            backgroundColor: 'rgba(0,0,0,0.3)',
            padding: 50
        };

        const modalStyle = {
            backgroundColor: '#fff',
            borderRadius: 5,
            maxWidth: 400,
            minHeight: 150,
            margin: '0 auto',
            marginTop: '125px',
            padding: 30
        };

        if(!this.props.showModalWindow){
            return null;
        }

        return (
            <div style={backdropStyle}>
                <div id="modalWindow" style={modalStyle}>
                    <div>
                        <div>
                            <span>Open Website</span>
                        </div>
                    </div>
                    <div>
                        <div className="modal-links">
                            <a href="" onClick={(e) => this.props.closeModal(e)}>Cancel</a>
                            <a href="" onClick={(e) => this.openWebsite(e)}>English Website</a>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default ModalDrugWebsite;


// WEBPACK FOOTER //
// ./src/ModalDrugWebsite.js